/* This file is autogenerated, see readme.md for instructions */
import ChatSvgIcon from '@bloomreach/banana-theme/icons/chat.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ChatIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ChatSvgIcon />
    </Icon>
  );
});

ChatIcon.displayName = 'ChatIcon';

export default ChatIcon;
